module.exports = __webpack_public_path__ + "static/media/iconfinder_Meditation_4042272.a738c49b.svg";